import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import { SwitchWithLabel } from '../../../../components/form/Switch'

const RedirectionSection = () => {
  const { t } = useTranslation('editDynamicServiceOrders')

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('redirectionSection')}
      </Title>
      <Line />
      <Separator weight={4} />

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%" wrapOn="sm">
          <FormItem label={t('redirectionLabel')} field={'redirectToExecution'} Input={SwitchWithLabel} ignoreLabel />
        </Col>
      </Grid>
    </>
  )
}

export default RedirectionSection
